import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function GetStoresDataToAssociateWithAccountService(token) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/account/getStoresDataToAssociateWithAccount`, '', {
        
        headers: {
            'Authorization': token,
        }
    }).then().
        then(res => {return res.data;
        }).catch(error => {  
            console.log(error)            
            notify.NotifyError("An error occurred while Fetching Accounts Details, please try again later.");
            return false;
        
        });
}
export  default GetStoresDataToAssociateWithAccountService